"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Boilerfeedhero() {
  return <section data-section-id="1987" id="boilerfeedhero" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {/* Fondo de Imagen con efecto Ken Burns */}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/plumbing_mechanical_service.png" alt="Technician performing maintenance on a commercial pump system" loading="eager" decoding="async" className="h-full w-full object-cover animate-[kenburns_20s_ease-in-out_infinite_alternate]" />
      </div>

      {/* Degradado oscuro para asegurar legibilidad del texto */}
      <div className="absolute inset-0 z-10" style={{
      background: "linear-gradient(to bottom, hsla(220, 95%, 10%, 0.85) 0%, hsla(220, 95%, 10%, 0.65) 45%, hsla(220, 95%, 10%, 0.9) 100%)"
    }} />

      {/* Contenedor Principal de Contenido */}
      <div className="relative z-20 mx-auto flex min-h-screen w-full max-w-7xl flex-col px-6 pt-32 pb-24 md:px-10 lg:px-16">
        <div className="flex flex-1 items-center">
          <div className="max-w-4xl">
            
            {/* Top Tagline */}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-accent" />
              <span className="font-default text-xs tracking-[0.25em] uppercase text-accent font-bold">
                Commercial Plumbing Services / Miami & South Florida
              </span>
            </div>

            {/* H1 Adaptado al responsive gigante */}
            <h1 className="font-default font-bold leading-[0.95] tracking-tight text-white mb-6" style={{
            fontSize: "clamp(3.5rem, 10vw, 6.5rem)"
          }}>
              Boiler Feed <br />
              <span className="text-accent">Pump Service</span>
            </h1>

            {/* Párrafo Descriptivo */}
            <p className="mt-8 max-w-2xl font-default text-lg leading-relaxed md:text-xl text-white/90">
              Seals wear thin and start to leak. Bearings overheat from friction. Scale and sediment build inside the pump casing and choke the flow. Motors draw more current than they should, tripping breakers and wearing down the system long before anyone notices a real failure.
            </p>

            {/* Acciones (Botón del UI kit + Teléfono clickeable) */}
            <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
              <Link to="#">
                <Button size="lg" className="bg-accent text-black hover:bg-accent-hover active:bg-accent-active hover:-translate-y-1 active:translate-y-0 hover:scale-105 active:scale-95 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-medium hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring px-10 py-5 text-base md:text-lg font-semibold rounded-lg">
                  Get Started
                </Button>
              </Link>
              
              <span className="font-default text-white/90 ml-2 font-semibold">
                Or call us at{" "}
                <a href="tel:3055613895" className="text-accent hover:underline hover:opacity-80 transition-all">
                  305-561-3895
                </a>
              </span>
            </div>

          </div>
        </div>

        {/* Indicador de Scroll hacia abajo */}
        <div className="relative mt-auto flex items-end justify-between pt-12">
          <div className="flex flex-col items-center gap-3">
            <span className="font-default text-[10px] tracking-[0.4em] uppercase text-white/70" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Scroll
            </span>
            <div className="relative h-16 w-px overflow-hidden">
              <div className="absolute inset-0 animate-[scrollLine_2s_ease-in-out_infinite] bg-white/60" />
            </div>
          </div>
        </div>
      </div>

      {/* Estilos locales para las animaciones del Hero */}
      <style>{`
        @keyframes kenburns { 0% { transform: scale(1) translate(0, 0); } 100% { transform: scale(1.12) translate(-1%, -1%); } }
        @keyframes scrollLine { 0% { transform: translateY(-100%); } 100% { transform: translateY(100%); } }
      `}</style>
    </section>;
}